import { Dashboard } from "api/model/dashboard/Dashboard";
import { DashboardLayoutType } from "api/model/dashboard/DashboardComponent";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import useDashboardStore from "store/dashboard-store";
import { T } from "services/lang/LanguageService";

const initialNewGroupTitle = "New Group";

interface AddNewTabGroupProps {
  dashboard: Dashboard;
  addNewGroupDialogVisibility: boolean;
  setAddNewGroupDialogVisibility: (addNewGroupDialogVisibility: boolean) => void;
  tabId: number;
  updateQuery: any;
  isReports?: boolean;
}

const AddNewTabGroup = (props: AddNewTabGroupProps) => {
  const [newGroupTitle, setNewGroupTitle] = useState<string>(initialNewGroupTitle);

  const setDashboard = useDashboardStore(state => state.setDashboard);

  const handleAddNewTabGroup = (groupTitle: string) => {
    props.setAddNewGroupDialogVisibility(false);
    setNewGroupTitle(initialNewGroupTitle);

    const currentTabIndex = props.tabId;
    const currentComponentGroups = props.dashboard.dashboardTabsJs[currentTabIndex].componentGroups;

    const newComponentGroup = {
      id: uuidv4(),
      title: groupTitle,
      layout: {
        type: props.isReports ? DashboardLayoutType.GRID : DashboardLayoutType.HORIZONTAL_FLEX,
      },
      components: [],
    };

    const updatedComponentGroups = [...currentComponentGroups, newComponentGroup];
    const updatedCurrentDashboard = {
      ...props.dashboard,
      dashboardTabsJs: props.dashboard.dashboardTabsJs.map((tab, index) => {
        if (index === currentTabIndex) {
          return {
            ...tab,
            componentGroups: updatedComponentGroups,
          };
        }
        return tab;
      }),
    } as Dashboard;

    setDashboard(updatedCurrentDashboard);
    props.updateQuery.mutate(updatedCurrentDashboard);
  };

  const addNewGroupFooter = () => {
    return (
      <div>
        <Button
          label={T("word.cancel")}
          icon="pi pi-times"
          onClick={() => props.setAddNewGroupDialogVisibility(false)}
          className="component-editor-button icon-red"
        />
        <Button
          label={T("action.save")}
          icon="pi pi-check"
          onClick={() => handleAddNewTabGroup(newGroupTitle)}
          className="component-editor-button icon-green"
        />
      </div>
    );
  };
  return (
    <Dialog
      header={T("action.add-new-tab-group")}
      className="w-30rem"
      visible={props.addNewGroupDialogVisibility}
      footer={addNewGroupFooter}
      onHide={() => props.setAddNewGroupDialogVisibility(false)}
    >
      <div className="flex flex-column gap-2">
        <label htmlFor="groupTitle">{T("label.group-title")}</label>
        <InputText
          value={newGroupTitle}
          className="w-full"
          onChange={e => {
            setNewGroupTitle(e.target.value);
          }}
        />
      </div>
    </Dialog>
  );
};

export default AddNewTabGroup;
